import api from '@/common/api'

export default {
  login(params: any) {
    return api.post(`/sign-in`, params).then((res: any) => {
      return res.data.data
    })
  },

  changePassword(params: {
    password: any,
    password_confirm: any
  }) {
    return api.post('/password', params).then((res: any) => {
      return res.data.data
    })
  },

  getProductInfo(id: string) {
    return api.get(`/product/${id}`).then((res: any) => {
      return res.data.data
    })
  },

  getInfomationList(params: {
    limit: number
    offset: number
  }) {
    return api.get(`/new`, { params }).then((res: any) => {
      return res.data.data
    })
  },

  getInfomationDetail(id: string) {
    return api.get(`/new/${id}`).then((res: any) => {
      return res.data.data
    })
  }
}